import { render, staticRenderFns } from "./fdInventory35.vue?vue&type=template&id=2f2b47fe"
import script from "./fdInventory35.vue?vue&type=script&lang=js"
export * from "./fdInventory35.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports